import r, { OPTIONS as D } from "../managers/braze-instance.js";
import na from "./push-manager.js";
const ra = {
  i: !1,
  na: null,
  ra: () => (
    ra.t(),
    ra.na ||
      (ra.na = new na(
        r.br(),
        r._a(),
        r.ue(),
        r.V(),
        r.re(D.Ga),
        r.re(D.Ha),
        r.re(D.Ia),
        r.l(),
        r.re(D.Ka),
        r.re(D.La),
        r.p(),
      )),
    ra.na
  ),
  t: () => {
    ra.i || (r.g(ra), (ra.i = !0));
  },
  destroy: () => {
    (ra.na = null), (ra.i = !1);
  },
};
export default ra;
